const escape = (value) =>
  typeof CSS !== 'undefined' && typeof CSS.escape === 'function'
    ? CSS.escape(value)
    : String(value).replace(/["\\]/g, '\\$&');

export const gapAnchor = (kind, id) => `${kind}:${id}`;

const parts = (anchor) => {
  const list = (Array.isArray(anchor) ? anchor : [anchor]).filter(Boolean);
  return { main: list[0] ?? null, also: list[1] ?? null };
};

export const anchorAttributes = (anchor, empty) => {
  const { main, also } = parts(anchor);
  if (!main) return {};
  const attributes = { 'data-gap-anchor': main };
  if (also) attributes['data-gap-also'] = also;
  if (empty !== undefined && empty !== null) attributes['data-gap-empty'] = String(Boolean(empty));
  return attributes;
};

const present = (id) => id !== null && id !== undefined && id !== '';

export const anchorProps = (kind, id) => {
  if (Array.isArray(kind)) return anchorAttributes(kind);
  if (!kind) return {};
  if (Array.isArray(id)) {
    return anchorAttributes(id.filter(present).map((entry) => gapAnchor(kind, entry)));
  }
  return present(id) ? { 'data-gap-anchor': gapAnchor(kind, id) } : {};
};

export const gapGroupProps = { 'data-gap-group': '' };

export const gapClusterProps = { 'data-gap-cluster': '' };

export const gapPartProps = { 'data-gap-part': '' };

export const controlAnchorProps = (anchor, empty) => anchorAttributes(anchor, empty);

export const isWildcardAnchor = (anchor) => String(anchor).includes('*');

const selectorOn = (attribute, text) => {
  const star = text.indexOf('*');
  if (star === -1) return `[${attribute}="${escape(text)}"]`;
  const head = text.slice(0, star);
  const tail = text.slice(star + 1);
  return `[${attribute}${head ? `^="${escape(head)}"` : ''}]${
    tail ? `[${attribute}$="${escape(tail)}"]` : ''
  }`;
};

export const anchorSelector = (anchor) => {
  const text = String(anchor);
  return `${selectorOn('data-gap-anchor', text)},${selectorOn('data-gap-also', text)}`;
};

export const isAnchorLaidOut = (anchor) => {
  if (typeof document === 'undefined') return false;
  return [...document.querySelectorAll(anchorSelector(anchor))].some((el) => {
    const rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  });
};
